import * as React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import ZoneSelect from '../../components/cart/zone-select';
import { sumPrices } from '../../helpers/pricing-helpers';
import { CombineCartViewProps } from '../../components/cart/cart-item';
import { AlternateCartItemType } from '../../classes/package-listing';


const CartItemView: React.StatelessComponent<CombineCartViewProps> = props => {
    const itemId = props.cartItem.cartItemId;

    return (
        props.showSeatMapOnly && props.isUnseated ?
            <>
                <ZoneSelect
                    showPriceTypeError={true}
                    showSeatMapOnly={true}
                    hideSeatMap={false}
                    itemId={itemId}
                    selectedZone={props.selectedZone}
                    disabledZoneIds={[]}
                    isSecondZone={false} />
            </>
            :
            <li key={itemId}>
                <div className="stack">
                    {
                        (props.itemTitle && props.showTitleAndRemoveButton) &&
                        <>
                            <div className="flex-between align-items-center">
                                <p className="ace-subs-cart-item-info"
                                    data-demo-label={props.itemDateString !== '' ? "Performance Title" : "Package Title"}>
                                    <span>{props.itemTitle}</span>
                                </p>
                                {
                                    props.showRemoveButton &&
                                    <button type="button" className="btn-link" onClick={() => {

                                        props.removeItem(props.itemIdToRemove)
                                        props.disablePerfButtons(false);
                                    }
                                    }>
                                        <span>{props.text.removeButtonText}</span>
                                    </button>
                                }
                            </div>
                            <p><span className="bold">{props.itemDateString} </span></p>
                        </>
                    }
                    {
                        props.isUnseated &&
                        <>
                            <ZoneSelect showSeatMapOnly={false}
                                showPriceTypeError={true}
                                hideSeatMap={props.hideSeatMap}
                                itemId={itemId}
                                selectedZone={props.selectedZone}
                                disabledZoneIds={[]}
                                isSecondZone={false}
                            />
                            {
                                props.isFixedPackage && props.showAlternateChoiceSection &&
                                <>
                                    <div className="stack">
                                        <p className="bold">{props.text.packageSecondChoiceLabel}</p>
                                        {
                                            props.showAlternateReservationCheckbox &&
                                            <>
                                                <input
                                                    name={"alternate-package-request-type-" + props.cartItem.cartItemId}
                                                    type="checkbox"
                                                    checked={
                                                        props.cartItem.selectedAlternateItem?.type === AlternateCartItemType.ZONE
                                                    } />
                                                <label
                                                    htmlFor={"alternate-package-request-type-" + props.cartItem.cartItemId}
                                                    onClick={() => {
                                                        props.toggleAlternateRequestType(props.cartItem.cartItemId)
                                                        props.disablePerfButtons(props.disableAllSeries ? false : true)
                                                    }}
                                                    className="alternate-reservation-label"
                                                >

                                                    <div className="rich-text"><div dangerouslySetInnerHTML={{ __html: props.text.packageSecondChoiceMessaging }} /></div>
                                                </label>
                                            </>
                                        }
                                    </div>
                                    {
                                        props.cartItem.selectedAlternateItem?.type === AlternateCartItemType.ZONE &&
                                        <ZoneSelect showPriceTypeError={true}
                                            itemId={itemId}
                                            selectedZone={props.selectedSecondZone}
                                            disabledZoneIds={props.selectedZone != null ? Array(1).fill(props.selectedZone?.zone?.id) : Array()}
                                            isSecondZone={true}
                                            showSeatMapOnly={false}
                                        />
                                    }
                                    {
                                        Boolean(props.cartItem.selectedAlternateItem?.type === AlternateCartItemType.PACKAGE &&
                                            props.cartItem.selectedAlternateItem.cartItemId) &&
                                        <>
                                            <div className="flex-between align-items-center">
                                                <p className="ace-subs-cart-item-info"
                                                    data-demo-label={props.itemDateString !== '' ? "Performance Title" : "Package Title"}>
                                                    <span>{props.alternateItemTitle}</span>
                                                </p>
                                                {
                                                    props.showRemoveButton &&
                                                    <button type="button" className="btn-link" onClick={() => props.removeItem(props.itemIdToRemove, true)}>
                                                        <span>{props.text.removeButtonText}</span>
                                                    </button>
                                                }
                                            </div>
                                            <ZoneSelect showPriceTypeError={true}
                                                itemId={props.cartItem.selectedAlternateItem.cartItemId}
                                                selectedZone={props.selectedSecondZone}
                                                disabledZoneIds={[]}
                                                isSecondZone={true}
                                                showSeatMapOnly={false}
                                            />
                                        </>
                                    }
                                </>
                            }
                            {
                                props.itemProcessErrorMessage.length > 0 &&
                                <span className="field-validation-error">{props.itemProcessErrorMessage}</span>
                            }
                        </>
                    }
                </div>
            </li>
    );
}

export default CartItemView;